import React from 'react'

export const VideoCount = props => (
  <div className="video_count">
    <span className="slide_count">{props.active + 1}</span> OF
    <span> {props.videos.length}</span>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/videoCount/index.js